module.exports = __webpack_public_path__ + "static/vraa01-c1215e1e31aa65d8d609e20874039f1f.png";